export default "__VITE_ASSET__DnTEsF6c__"